import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Rating from "@mui/material/Rating";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Http, appLogger } from "../../../../../utils";
import { useContext, useEffect, useState } from "react";
import { UserLoginInfo } from "../../../../../types/context";
import { UserContext } from "../../../../../context/userContext";
import { IFeedbackAgentSettings } from "../../../../../model";
import { getDateTime } from "../../../../../utils/data";
import { Divider } from "@mui/material";

interface Iprops {
  productId: string;
  productVersion: string;
  topic: string;
}

const GoogleReview = ({ productId, productVersion, topic }: Iprops) => {
  const [review, setReview] = useState([]);
  const { userInfo } = useContext(UserContext) as UserLoginInfo;

  const fetchGoogleReview = async () => {
    if (productId && productVersion && topic) {
      Http.get({
        url: `/api/v2/correlation/playstore?prodId=${productId}&prodVersion=${productVersion}&correlatedValue=${topic}`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.Items &&
            response.Items.Items &&
            response.Items.Items.length > 0
          ) {
            response.Items.Items.length = 5;
            setReview(response.Items.Items);
            appLogger.info({
              infoObj: {
                method: "fetchGroup",
                component: "add-product",
                fileName: "basicDetails.tsx",
                groupResponse: response,
              },
            });
          } else {
            // props.snackbarShowMessage("No Group Found", "error");
          }
        })
        .catch((error: any) => {
          appLogger.error({
            errObj: {
              method: "fetchGroup",
              component: "add-product",
              fileName: "basicDetails.tsx",
              err: error,
            },
          });
        });
    }
  };

  useEffect(() => {
    fetchGoogleReview();
  }, []);

  const renderReview = (reviewData: any, index: number) => {
    return (
      <>
        <Grid container mt="13px">
          <Grid container>
            <Box display="flex" alignItems="center" gap="17px">
              <Box>
                <Avatar sx={{ width: "30px", height: "30px" }} />
              </Box>
              <Box>
                <Typography className="info reportstickets">
                  Anonymous
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid container mt="13px">
            <Box display="flex" alignItems="normal" gap="8px">
              <Rating
                size="small"
                readOnly
                value={
                  reviewData
                    ? reviewData["StarRating"]
                      ? reviewData["StarRating"]
                      : 0
                    : 0
                }
              />
              <Box>
                <Typography className="info reportstickets">
                  {reviewData
                    ? reviewData["sentiment"]
                      ? reviewData["sentiment"]
                      : ""
                    : ""}
                </Typography>
              </Box>
              <Box>
                <Typography className="info reportstickets">
                  {reviewData
                    ? reviewData["ReviewLastUpdateDateandTime"]
                      ? getDateTime(reviewData["ReviewLastUpdateDateandTime"])
                      : ""
                    : ""}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid container mt="13px">
            <Grid item xs={12}>
              {" "}
              <Typography className="title-sm-fb">Comment</Typography>
              <Typography className="info reportstickets">
                {reviewData
                  ? reviewData["ReviewText"]
                    ? reviewData["ReviewText"]
                    : ""
                  : ""}
              </Typography>
            </Grid>
          </Grid>

          {/* <Grid item xs={12}>
            {" "}
            <Typography
              className="title-sm-fb"
            >
              Topics
            </Typography>
            {reviewData &&
              reviewData["topics"].length > 0 &&
              reviewData["topics"].map((el: string, i: number) => {
                return (
                  <Typography className="info reportstickets">
                    {i + 1}. {el}
                  </Typography>
                );
              })}
          </Grid> */}
        </Grid>

        <br></br>
        {index != 4 && <Divider></Divider>}
      </>
    );
  };

  return (
    <Accordion
      expanded
      disableGutters
      elevation={0}
      square
      sx={{
        marginTop: "15px",
        border: "1px solid #dbdce0",
        borderRadius: "8px",
        background: "rgba(32, 33, 36, 0.03)",
        "&::before": {
          display: "none!important",
        },
        "& .MuiAccordionDetails-root": {
          background: "#FFF",
          borderRadius: "0 0 8px 8px",
        },
      }}
    >
      <AccordionSummary
        // expandIcon={<KeyboardArrowUpIcon />}
        aria-controls={"panel1-content"}
        id={"panel1-header"}
        sx={{
          fontFamily: "Poppins",
          fontWeight: 600,
          fontSize: "14px",
        }}
      >
        <Grid
          container
          className="acc-prod-icon"
          justifyContent="space-between"
        >
          <Grid item spacing={2} className="acc-prod-icon">
            Google Review
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid>
          {review &&
            review.length &&
            review.map((r, index) => {
              return renderReview(r, index);
            })}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default GoogleReview;
